import React, {useState, useEffect} from 'react'
import apiClient from '../api/apiClient'

export default function AddAssessorModal(props){
    const {schoolID, testGroupID, term_id, onClose, addCensor} = props;
    const [assignableCensors, setAssignableCensors] = useState([])
    const [formData, setFormData] = useState({
        censorID: null, 
        testGroupID: testGroupID
    })

    async function fetchAssessor(){
        try{
            const result = await apiClient.get('/api/testgroup/getassessors',{
                params: {schoolID: schoolID, term_id : term_id}
            })
            setAssignableCensors(result.data)
            console.log("success")
            console.log(result.data)
        }catch(e){
            console.log("errro in fetch censor")
            console.log(e)
        }
    }

    useEffect(()=>{
        fetchAssessor()
    }, [])

    function handleSubmit(e){
        e.preventDefault()

        const censorID = formData.censorID
        console.log(`censorid er ${censorID} testgroup_Id er ${formData.testGroupID}`)

        addCensor(formData)

    }


    return(
        <div className="modal-overlay">
            <div className="modal-content">
                <div className="modal-header">
                    <h2 className="modal-title">Tilføj censor</h2>
                    <button className="close-btn" onClick={onClose}>&times;</button>
                </div>
                <form onSubmit={(e)=>handleSubmit(e)}>
                    <div className="modal-form-grid">
                        <div className="form-group">
                            <label>Vælg censor:</label>
                            <select value={formData.censorID} 
                            onChange={(e)=>{setFormData({...formData, censorID: parseInt(e.target.value)})}}>
                                <option key="0" value="0">Ikke valgt</option>
                                {assignableCensors.map(censor =>(
                                    <option key={censor.id} value={censor.id}> {censor.fornavn} {censor.efternavn}</option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <div className="modal-actions" style={{marginTop: '20px'}}>
                        <button type="button" className="btn-cancel" onClick={onClose}>Annuller</button>
                        <button type="submit" className="btn-save"   >Tilføj</button>
                    </div>
                </form>
            </div>
        </div>
    )
}